import * as React from "react";
import * as moment from "moment";
import { ILogisticsOptionNote } from "@nkr/models/index";

interface IProps {
    index: number,
    note: ILogisticsOptionNote
    userId: number
    readonly: boolean,
    onEdit: (index: number) => void,
    onDelete: (index: number) => void
}

class OptionNotesRow extends React.Component<IProps, {}> {
    handleEdit = () => {
        this.props.onEdit(this.props.index);
    }

    handleDelete = () => {
        this.props.onDelete(this.props.index);
    }

    render = () => {
        return (
            <tr>
                <td>{moment(this.props.note.logDateTime).format('MM/DD/YY @ HH:mm')}</td>
                <td>{this.props.note.notes}</td>
                <td>{this.props.note.createdBy}</td>
                <td>
                    {this.props.note.userId == this.props.userId && (
                        <>
                            <button className="btn btn-notes btn-xs" style={{ marginRight: 5 }} disabled={this.props.readonly} onClick={this.handleEdit}>Edit</button>
                            <button className="btn btn-notes btn-xs" disabled={this.props.readonly} onClick={this.handleDelete}>Delete</button>
                        </>
                    )}
                </td>
            </tr>
        )
    }
}

export default OptionNotesRow;